const feature = [
    {
        id:1,
        title: "Suits Your Style",
        subTitle: "Ned ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque."
    },
    {
        id:2,
        title: "Well Documented",
        subTitle: " Ned ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque."
    },
    {
        id:3,
        title: "Highly Customizable",
        subTitle: " Ned ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque."
    },
]

export default feature